import React from "react"
import DetailView from "./detailView";

const PictureDom = (props)=>{
    let accessType = props.accessType   
    let templateJson = {};
    templateJson.pict_height = photoOrg.pictureSize;
    templateJson.id = props.assetId;
    templateJson.thumbnailParam = 'height=200';
    templateJson.AssetType = props.assetType;
    templateJson.idStr = "po_sav";
    templateJson.accessType=accessType;
    templateJson.isRearrangeMode=false;//adding default value
    templateJson.pictTitle = props.caption;
    if(!templateJson.pictTitle)
        templateJson.pictTitle = photoOrg.translations.photos["no_title_friends_albums"];
        templateJson.pictTitle = photoOrg.photoLib.removeExtInTitle(templateJson.pictTitle);
    console.log("entry level double ", templateJson.pictTitle);
    if(props.assetType == "VIDEO"){
        templateJson.imgUrl = photoOrg.assetUtils.getVideoImageUrl(props.thumbnailEncryption);
    }else{
        templateJson.imgUrl = photoOrg.Util.getTnlURLFromArray(props.thumbnailEncryption, props.assetId);
    }
    //calculate proportinate value of  width, using height
    templateJson.height = 200;
    try{
        //adjusted width = <user-chosen height> * original width / original height
        templateJson.width = 200 * props.width / props.height;
    }catch (e){
        templateJson.width = 200
    }
    templateJson.thumbnailParam = 'height=200'
    try {
        //for panaroma images
        if (props.width - props.height > 2*parseInt(props.height)  ) {
            templateJson.thumbnailParam = 'width=' + (document.getElementById("assetGrid").offsetWidth
             || document.getElementById("pfluidGrid").offsetWidth);
        }
    }catch(e){
    }
    templateJson.tnlUrl = ""
    if(templateJson.imgUrl && templateJson.imgUrl.length > 0){
        templateJson.tnlUrl = templateJson.imgUrl + "?" + templateJson.thumbnailParam
    }
    return (
        <React.Fragment>
            {
            (!photoOrg.browserUtil.isMobileDevice() && props.showTitle) ? 
            <label  className={`title_${props.id} pictTitle nonEditable`} data-testid="show_title" title={templateJson.pictTitle }>{templateJson.pictTitle }</label>:""
            }
            
            <div className="selection-border click-on-asset"></div>
            <a onClick={(e)=>DetailView(e)} className="magnifying-icon detail-view-trigger" name="public_share_magnifying_icon" title={photoOrg.translations.photos["asset_option"]["magnify_tooltip"]}   aria-label={photoOrg.translations.photos["asset_option"]["magnify_tooltip"] +  photoOrg.translations.photos["aria_label"]["opens_dialog"]}></a> 
            <div id={`select_id${templateJson.id}${templateJson.idStr}`}></div>
            
            {
            (photoOrg.Util.isNativeLazySupports) ?
            <img className="assetImg cs" loading="lazy" onError={photoOrg.Util.addImageLoadingErrorEvent} src={templateJson.tnlUrl}  alt="user images" name={templateJson.id} id={"img_"+templateJson.id  +" " + templateJson.idStr}  />
            :
            <img className="assetImg lazy sc" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC" alt="user images"  data-original={templateJson.tnlUrl} name={templateJson.id} id={"img_"+templateJson.id  +" " + templateJson.idStr}  />        
            }
        </React.Fragment>
        );
}

export default PictureDom;